import React from "react";

export default function Footer(){

    return(
        <div className="footer">
        <footer>
        Copyright &copy; 2023
    </footer>
        </div>

    )
}